import { render, staticRenderFns } from "./DialogBuilder.vue?vue&type=template&id=ad8dd2c0"
import script from "./DialogBuilder.vue?vue&type=script&lang=js"
export * from "./DialogBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports